import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-random-message',
  templateUrl: './random-message.component.html',
  styleUrls: ['./random-message.component.scss']
})
export class RandomMessageComponent implements OnInit {

  public title: string;
  public message: string;

  constructor(public dialogRef: MatDialogRef<RandomMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string | null) {

    if (this.data == null) {
      return;
    }

    this.getContent(data);
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  getContent(data) {
    if (data && typeof data === 'object' && 'title' in data) {
      this.message = data.message;
      this.title = data.title;
    } else {
      this.message = data;
    }
  }
}
